<template>
  <div
    :class="{
      warn1: true,
      slash: customerId != 3 ? true : false,
      'red-warn1': data.level === 2 ? true : false,
      'yellow-warn1': data.level === 1 ? true : false,
      warn1_green: styleType == 'typeGreen',
      'red-warn1_green':
        data.level === 2 && styleType == 'typeGreen' ? true : false,
      'yellow-warn1_green':
        data.level === 1 && styleType == 'typeGreen' ? true : false,
    }"
  >
  <template v-if="dutyModShowLikePc">
     <warnPc :itemData="data"></warnPc>
  </template>
    <template v-else>
    <div class="warn1_title">
      <div
        class="popup-type1-title"
        :class="{ 'popup-type1-title_green': treatType }"
      >
        <template v-if="data.analyzeResult && data.warnType == 5"
          >{{ "道路" }}-{{ "污染识别" }}</template
        >
        <template
          v-else-if="
            data.warnType == 3 ||
            data.warnType == 150 ||
            data.warnType == 18 ||
            data.warnType == 1003 ||
            data.warnType == 1004 ||
            data.warnType == 1005 ||
            data.warnType == 1014
          "
        >
          {{ data.eventName }}
        </template>
        <template v-else-if="data.warnType == 100">{{
          data.typeName + "-" + "高频高辐"
        }}</template>
         <template v-else-if="data.warnType == 6044">{{
          data.typeName + "-" + data.eventName
        }}</template>
        <template v-else>
          {{ data.typeName }}-{{
            data.metric +
            (data.warnType === 1 && data.metric === "TSP"
              ? "告警"
              : data.warnType === 1 && data.metric === "VDM浓度"
              ? "告警"
              : data.warnType === 1
              ? "超标"
              : data.warnType === 2
              ? "超低"
              : data.warnType === 99
              ? "恒值"
              : data.warnType == 10
              ? "持续超标"
              : data.warnType == 11
              ? "三倍超标"
              : "")
          }}
        </template>
      </div>
      <div class="popup-type1-time" v-if="data.warnType == 5">
        {{ data.createTime ? data.createTime.slice(5, 16) : "" }}
      </div>
      <div class="popup-type1-time" v-else>
        {{ data.eventTime ? data.eventTime.slice(5, 16) : "" }}
      </div>
    </div>

    <div class="warn1_content">
      <div class="warn1_state">
        闭环控制状态:
        <span :class="{ done_green: treatType }">{{ handleState_ }}</span>
      </div>
      <div class="warn1_branchFac" v-if="data.branchFactory">
        所属区域:
        <span>{{ data.branchFactory }}</span>
      </div>
      <div class="warn1_position">
        发生位置:
        <span>{{ data.deviceName }}</span>
        <span
          style="
            font-size: 16px;
            color: rgb(204, 204, 204);
            display: block;
            text-align: center;
            padding: 5px 0;
          "
        >
          {{
            sourceData && sourceData.length > 0 && data.warnType != 5
              ? "相关排放源数量(" + sourceData.length + ")"
              : ""
          }}
        </span>
      </div>
      <div class="warn1_branchFac" v-if="customerId == 53">
        超标原因:
        <span>{{ data.reason ? data.reason : "无" }}</span>
      </div>
      <div class="warn1_branchFac" v-if="customerId == 53">
        处理措施:
        <span>{{ data.measure ? data.measure : "无" }}</span>
      </div>
      <template v-if="data.warnType == 5">
        <div class="warn1_road_info">
          统计时间:
          <span>
            {{ data.analyzeResult.startTime }} ~
            {{
              data.analyzeResult.endTime
                ? data.analyzeResult.endTime.slice(11, 19)
                : ""
            }}
          </span>
        </div>
        <div class="warn1_road_info">
          全厂PM10均值:
          <span>
            {{
              data.analyzeResult.pm10AvgFactory
                ? data.analyzeResult.pm10AvgFactory
                : "--"
            }}
            μg/m³
          </span>
        </div>
        <div class="warn1_road_info">
          PM10均值:
          <span>
            {{
              data.analyzeResult.pm10AvgRoad
                ? data.analyzeResult.pm10AvgRoad
                : "--"
            }}
            μg/m³
          </span>
        </div>
        <div class="warn1_charts new-chart-style" v-if="data.chartRoadPM10">
          <div class="warn1_charts_inner" ref="chartRoadPM10"></div>
        </div>
        <div
          class="warn1_road_info"
          v-if="data.analyzeResult && data.analyzeResult.vdmAvgRoad"
        >
          VDM均值:
          <span>{{ data.analyzeResult.vdmAvgRoad }} μg/m³</span>
        </div>
        <div
          class="warn1_charts new-chart-style"
          v-if="data.analyzeResult && data.analyzeResult.vdmAvgRoad"
        >
          <div class="warn1_charts_inner" ref="chartRoadVDM"></div>
        </div>
      </template>
    </div>
    <template v-if="data.warnType != 5">
      <div class="warn1_box" v-show="!treatType">
        <div class="smallBox">
          <!-- 2022-12-13配合AUR需求新增判断warnType==20或21则展示signalName（信号名）-->
          <div class="warn1_type_name">
            {{
              data.warnType === 20 || data.warnType === 21
                ? "信号名"
                : data.warnType === 100
                ? "超值次数"
                : data.warnType === 150
                ? "运行时长"
                : data.warnType === 6044
                ? data.eventName
                : data.metric
            }}
          </div>
          <div class="warn1_type_num" v-if="data.warnType !== 18">
            {{
              data.warnType === 99
                ? data.totalConstantTime
                : data.warnType === 4
                ? data.value
                : data.warnType === 20 || data.warnType === 21
                ? data.signalName
                : data.warnType === 100 || data.warnType === 150
                ? data.value
                : data.warnType === 6044
                ?  Number(data.value)?.toFixed(2) + "小时"
                : Number(data.value)?.toFixed(2)
            }}
          </div>
          <div v-else class="warn1_type_num cemsDesc">
            <p>在线监控(监测)</p>
            {{ viewData[data.cemsBreakdownTag] }}
          </div>
          <div class="warn1_type_unit" v-if="data.warnType !== 18">
            {{ data.warnType === 99 || data.warnType === 4 ? "" : data.unit }}
          </div>
        </div>
      </div>
    </template>
    <template v-if="data.warnType != 5 && data.warnType != 6044">
      <div class="warn1_charts" v-show="!treatType && haveData">
        <div class="warn1_charts_inner" ref="chart"></div>
      </div>
    </template>
    <div class="treatRecords">
      <div class="treatTitle">处理记录：</div>
      <ul class="treatList">
        <li class="treatEveryList" v-for="(item, i) in treatRecords" :key="i">
          <div class="listLeft">
            <div class="listStatus">{{ item.state }}</div>
            <div
              :title="item.receiveUserName"
              class="treatMan"
              v-show="Boolean(item.receiveUserName)"
            >
              {{ item.receiveUserName }}
            </div>
          </div>

          <div class="listTime">{{ item.createTime }}</div>
        </li>
      </ul>
    </div>
    <div
      class="warn1_project_25"
      :class="{
        warn1_project_50: getPercent(treatRecords) == '已分配',
        warn1_project_75: getPercent(treatRecords) == '处理中',
        warn1_project_100: getPercent(treatRecords) == '已处理',
      }"
    ></div>
    <div
      class="treatRecords"
      v-if="
        getPercent(treatRecords) == '已处理' && customerId == 53 && data.imgUrl
      "
    >
      <div class="treatTitle">处理完成结果展示：</div>
      <div class="treatList">
        <img class="detailImg" :src="data.imgUrl" />
      </div>
    </div>
    <div
      class="treatRecordsMore"
      v-if="
        getPercent(treatRecords) == '已处理' && customerId == 3 && data.imgUrl
      "
    >
      <div class="trmItem">
        <div class="title">原因分析：</div>
        <div class="value">{{ data.reason }}</div>
      </div>
      <div class="trmItem">
        <div class="title">处理措施：</div>
        <div class="value">{{ data.measure }}</div>
      </div>
      <div class="treatTitle">现场照片：</div>
      <div class="treatList">
        <!-- <img
          class="detailImgScale"
          :class="[isScale && 'scaleImgClass']"
          :src="data.imgUrl"
          @click="scaleImg()"
        /> -->
        <el-image
          style="height: 280px"
          :src="[data.imgUrl]"
          :preview-src-list="[data.imgUrl]"
        >
        </el-image>
      </div>
    </div>
    </template>
  </div>
</template>
<script>
import getOpt from "./js/chartOpt.js";
import { unwarp } from "@/utils/tools.js";
import { unref } from "vue";
import warnPc from "./warn1PcShow.vue"

export default {
  components: {warnPc},
  props: ["data", "typeId"],
  inject: ["getWarnSourceData"],
  data() {
    return {
      pageInfo: "warn1.vue",
      computedName: "闭环管理告警弹框组件",
      customerId: this.$store.state.customerId,
      dutyModShowLikePc: bmeConfig.dutyModShowLikePc,
      chart: null,
      chartRoadPM10: null,
      chartRoadVDM: null,
      unit: 1,
      handleState_: "",
      treatRecords: [],
      treatType: false,
      warnType: "",
      pmData: {
        xData: [],
        y1Data: [],
      },
      roadPM10Data: {
        xData: [],
        y1Data: [],
      },
      roadVDMData: {
        xData: [],
        y1Data: [],
      },
      haveData: true,
      sourceData: [],
      styleType: "",
      viewData: {
        D: "仪器仪表故障",
        B: "仪器仪表与数采通讯异常",
        VGD: "仪器仪表与数采通讯异常",
      },
      isScale: false,
    };
  },
  computed: {
    curStyleTypeVal() {
      return this.$store.state.styleType;
    },
    getPercent() {
      return (list) => {
        let nameList = Object.keys(list);
        let key = nameList[nameList.length - 1];
        if (list[key]) {
          return list[key].state;
        }
      };
    },
  },
  created() {
    // if (this.data.warnType === 4) {
    //   console.log(123)
    //   this.data.value = this.warnValueFilter(this.data.value)
    //   console.log(this.data, this.data.value)
    // }
    if (this.$store.state.customerId == 46) {
      this.data.metric = this.data.metric.replace("VDM", "TSP");
      this.data.typeName = this.data.typeName.replace("VDM", "TSP");
    }
    this.styleType = this.$store.state.styleType;
    if (this.$store.state.customerId == 46) {
      this.data.metric = this.data.metric.replace("VDM", "TSP");
      this.data.typeName = this.data.typeName.replace("VDM", "TSP");
    }
    this.styleType = this.$store.state.styleType;
  },
  watch: {
    data: {
      handler: function (newVal, oldVal) {
        if (newVal.warnType === 4 && typeof newVal.value === "number") {
          this.data.value = this.warnValueFilter(newVal.value);
        }
      },
      deep: true,
    },
    getWarnSourceData: {
      handler(newVal, oldVal) {
        let tmpObj = unref(newVal);
        this.sourceData = tmpObj;
      },
      deep: true,
    },
    curStyleTypeVal: {
      handler(newVal, oldVal) {
        this.styleType = newVal;
        this.typeChange();
      },
      deep: true,
    },
  },
  mounted() {
    this.treatRecords = this.data.forwards;
    if (this.treatRecords.length) {
      this.treatRecords.forEach((v, i) => {
        if (v.state == 1) {
          v.state = "已创建";
        } else if (v.state == 2) {
          v.state = "已处理";
        } else if (v.state == 3) {
          v.state = "已分配";
        } else if (v.state == 4) {
          v.state = "处理中";
        }
      });

      // 如果是道路让它只显示最后三条数据
      if (
        this.data.warnType == 5 &&
        this.chartRoadVDM &&
        this.treatRecords.length >= 3
      ) {
        this.treatRecords = this.treatRecords.slice(-3);
      }
    }
    if (this.data) {
      if (this.data.warnType == 1) {
        this.warnType = "超标";
      } else if (this.data.warnType == 2) {
        this.warnType = "超低";
      } else if (this.data.warnType == 3) {
        this.warnType = "同步率";
      }
    }
    if (this.data) {
      if (this.data.handleState == 0 || this.data.handleState == 1) {
        this.handleState_ = "处理中";
      } else if (this.data.handleState == 2) {
        this.handleState_ = "已处理";
        this.treatType = true;
      } else if (this.data.handleState == 3) {
        this.handleState_ = "已撤销";
        this.treatType = true;
      } else {
        this.handleState_ = "未知状态";
      }
    }
    if (this.data) {
      if (this.data.typeName && this.data.typeName.indexOf("微站") != -1) {
        this.data.typeName = "微站";
      } else if (
        this.data.typeName &&
        this.data.typeName.indexOf("CEMS") != -1
      ) {
        this.data.typeName = "CEMS";
      }
    }
    this.getData();
    this.typeChange();
  },
  unmounted() {},
  beforeUnmount() {
    if (this.chart) {
      this.chart.dispose();
      this.chart = null;
    }
  },
  activated() {
    this.getData();
  },
  methods: {
    warnValueFilter(offlineTime) {
      if (offlineTime == null || offlineTime <= 0) {
        return "--";
      }

      if (offlineTime < 60) {
        return offlineTime + "分钟";
      }

      if (offlineTime < 1440) {
        if (offlineTime % 60 == 0) {
          return offlineTime / 60 + "小时";
        } else {
          return (
            parseInt(offlineTime / 60) + "小时" + (offlineTime % 60) + "分钟"
          );
        }
      } else {
        let s;
        let d = parseInt(offlineTime / 60 / 24);
        let h = parseInt((offlineTime / 60) % 24);
        let m = offlineTime % 60;
        s = d + "天";
        if (h >= 1) {
          s += h + "时";
        }
        if (m > 0) {
          s += m + "分";
        }
        return s;
      }
    },
    typeChange() {
      if (this.styleType == "typeGreen") {
        this.$nextTick(() => {});
      } else if (this.styleType == "typeDark") {
        this.$nextTick(() => {});
      }
    },
    formatDate(date) {
      var date = new Date(date * 1000);
      var YY = date.getFullYear() + "-";
      var MM =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      var DD = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      var hh =
        (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
      var mm =
        date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      var ss =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      return YY + MM + DD + " " + hh + mm;
    },
    getData() {
      let that = this;
      if (this.data.valueHistory && this.data.valueHistory.length > 0) {
        let dpsObj = this.data.valueHistory[0].dps;
        if (dpsObj) {
          this.haveData = true;
          let arrNewX = [];
          let arrNewY = [];
          for (let i in dpsObj) {
            arrNewY.push(dpsObj[i] ? dpsObj[i].toFixed(2) : dpsObj[i]); //值 ['aaa' 190 'man']
            arrNewX.push(this.formatDate(parseInt(i))); //属性  ['name' 'height' 'sex']
          }
          this.pmData.xData = arrNewX;
          this.pmData.y1Data = arrNewY;
          this.$nextTick(() => {
            try {
              if (!that.chart) {
                that.chart = echarts.init(that.$refs.chart);
              }
              let optionStr = getOpt(that.pmData);
              unwarp(that.chart).setOption(optionStr);
            } catch (err) {
              console.log(err);
            }
          });
        }
      } else {
        this.haveData = false;
      }

      if (this.data.chartRoadVDM) {
        let dpsObj = this.data.chartRoadVDM;
        // let dpsObj = {
        //   1634205000: 4299.5,
        //   1634205600: 4691.277777777777,
        //   1634206200: 4504.722222222223,
        //   1634206800: 4247.176470588235,
        //   1634207400: 3348.0526315789475,
        //   1634208000: 4616.777777777777
        // }
        if (dpsObj) {
          this.haveData = true;
          let arrNewX = [];
          let arrNewY = [];
          for (let i in dpsObj) {
            arrNewY.push(dpsObj[i] ? dpsObj[i].toFixed(2) : dpsObj[i]); //值 ['aaa' 190 'man']
            arrNewX.push(this.formatDate(parseInt(i))); //属性  ['name' 'height' 'sex']
          }
          this.roadPM10Data.xData = arrNewX;
          this.roadPM10Data.y1Data = arrNewY;
          this.$nextTick(() => {
            try {
              if (!that.chartRoadVDM) {
                that.chartRoadVDM = echarts.init(that.$refs.chartRoadVDM);
              }
              let optionStr = getOpt(that.roadPM10Data);
              unwarp(that.chartRoadVDM).setOption(optionStr);
            } catch (err) {
              console.log(err);
            }
          });
        }
      }

      if (this.data.chartRoadPM10) {
        let dpsObj = this.data.chartRoadPM10;
        // let dpsObj = {
        //   1634205000: 4299.5,
        //   1634205600: 4691.277777777777,
        //   1634206200: 4504.722222222223,
        //   1634206800: 4247.176470588235,
        //   1634207400: 3348.0526315789475,
        //   1634208000: 4616.777777777777
        // }
        if (dpsObj) {
          this.haveData = true;
          let arrNewX = [];
          let arrNewY = [];
          for (let i in dpsObj) {
            arrNewY.push(dpsObj[i] ? dpsObj[i].toFixed(2) : dpsObj[i]); //值 ['aaa' 190 'man']
            arrNewX.push(this.formatDate(parseInt(i))); //属性  ['name' 'height' 'sex']
          }
          this.roadVDMData.xData = arrNewX;
          this.roadVDMData.y1Data = arrNewY;
          this.$nextTick(() => {
            try {
              if (!that.chartRoadPM10) {
                that.chartRoadPM10 = echarts.init(that.$refs.chartRoadPM10);
              }
              let optionStr = getOpt(that.roadVDMData);
              unwarp(that.chartRoadPM10).setOption(optionStr);
            } catch (err) {
              console.log(err);
            }
          });
        }
      }
    },
    scaleImg() {
      this.isScale = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.warn1 {
  position: absolute;
  padding: 30px;
  width: 450px;
  height: 782px;
  background: linear-gradient(180deg, #000000 0%, rgba(0, 0, 0, 0) 100%);
  background-size: 100% 100%;
  box-shadow: 0px -2px 0px 0px #51eeff, 0px 2px 4px 0px rgba(0, 0, 0, 0.74);
  overflow: hidden;
  overflow-y: auto;
  .warn1_title {
    display: flex;
    align-items: flex-end;
    border-bottom: 1px solid;
    border-image: linear-gradient(-90deg, #4fa7ff, #88f7ff) 1 1;
    justify-content: space-between;
    .popup-type1-title {
      height: 30px;
      font-size: 22px;
      font-weight: 500;
      color: #ff7373;
      line-height: 30px;
      display: flex;
      align-items: center;
      // flex-wrap: nowrap;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      flex: 1;
      text-align: left;
      &::before {
        content: "";
        display: block;
        width: 7px;
        height: 7px;
        background: #ff7373;
        box-shadow: 0px 0px 7px 0px #df3131;
        border: 1px solid #da3636;
        border-radius: 50%;
        display: inline-block;
        margin-right: 16px;
      }
    }
    .popup-type1-time {
      // height: 14px;
      padding-bottom: 5px;
      font-size: 14px;
      color: #ffffff;
      line-height: 14px;
      width: 90px;
    }
  }
  .warn1_content {
    margin-top: 20px;
    .warn1_state {
      height: 18px;
      font-size: 18px;
      font-weight: 400;
      color: #94a2b0;
      line-height: 18px;
      margin-bottom: 7px;
      span {
        color: #f4c48f;
        font-weight: 500;
      }
    }
    .warn1_branchFac {
      height: 18px;
      font-size: 18px;
      font-weight: 400;
      color: #94a2b0;
      line-height: 18px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      margin-bottom: 7px;
      span {
        color: #4fc5ff;
        font-weight: 500;
      }
    }
    .warn1_road_info {
      font-size: 18px;
      font-weight: 400;
      color: #94a2b0;
      line-height: 30px;
      span {
        color: #4fc5ff;
        font-weight: 500;
      }
    }
    .warn1_position {
      //height: 18px;
      font-size: 18px;
      font-weight: 400;
      color: #94a2b0;
      line-height: 18px;
      span {
        color: #4fc5ff;
        font-weight: 500;
      }
    }
    .new-chart-style {
      margin-bottom: 10px;
    }
  }
  .warn1_box {
    margin-top: 20px;
    width: 100%;
    height: 126px;
    background: rgba(0, 0, 0, 0.42);
    box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.66);
    padding: 13px 79px;

    .smallBox {
      @include bg-box(100%, 100px, "warn1_bg.png");
      text-align: center;
      padding-top: 10px;
      .warn1_type_name {
        height: 16px;
        font-size: 16px;
        color: #99f5ff;
        line-height: 16px;
        margin-bottom: 15px;
      }
      .warn1_type_num {
        height: 32px;
        font-size: 32px;
        color: #ffffff;
        line-height: 32px;
        margin-bottom: 5px;
        text-shadow: 2px 2px 2px rgba(255, 255, 255, 0.32);
      }
      .cemsDesc {
        font-size: 24px;
      }
      .warn1_type_unit {
        height: 12px;
        font-size: 12px;
        color: #aaaaaa;
        line-height: 12px;
        text-shadow: 2px 2px 2px rgba(255, 255, 255, 0.3);
      }
    }
  }
  .warn1_charts {
    width: 390px;
    height: 135px;
    margin-top: 10px;
    .warn1_charts_inner {
      width: 390px;
      height: 135px;
    }
  }
  .new-chart-style {
    width: 390px;
    height: 100px;
    margin-top: 5px;
    .warn1_charts_inner {
      width: 390px;
      height: 100px;
    }
  }
  .treatRecords {
    width: 100%;
    margin-top: 20px;
    .treatTitle {
      height: 18px;
      font-size: 18px;
      color: #94a2b0;
      line-height: 18px;
    }
    ul.treatList {
      padding-left: 30px;
      margin-top: 15px;
      position: relative;
      &::before {
        content: "";
        width: 1px;
        background-color: #51eeff;
        height: calc(100% - 40px);
        display: block;
        position: absolute;
        top: 20px;
        left: 15px;
      }
      li {
        height: 40px;
        border-bottom: 1px solid #4069ad;
        display: flex;
        font-size: 16px;
        color: #e8f2fc;
        line-height: 40px;
        align-items: center;
        position: relative;
        justify-content: space-between;
        .listLeft {
          display: flex;
          align-items: center;
          .listStatus {
            margin-right: 20px;
            &:before {
              content: "✔";
              color: #313131;
              line-height: 12px;
              width: 12px;
              height: 12px;
              font-size: 10px;
              top: 13px;
              background: #99f5ff;
              position: absolute;
              left: -20px;
              border-radius: 50%;
            }
          }
          .treatMan {
            width: 100px;
            height: 24px;
            background: #068acb;
            border-radius: 4px;
            line-height: 24px;
            text-align: center;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
    }
  }
  .treatRecordsMore {
    .trmItem {
      display: flex;
      height: 22px;
      font-size: 18px;
      line-height: 22px;
      letter-spacing: 1px;
      .title {
        color: #e1e4e7;
        margin-right: 1px;
      }
      .value {
        color: #5bc3f7;
      }
    }
    .treatTitle {
      height: 22px;
      font-size: 18px;
      color: #e1e4e7;
      line-height: 22px;
      letter-spacing: 1px;
    }
    .treatList {
      display: flex;
      justify-content: center;
      .detailImgScale {
        cursor: pointer;
      }
      // .scaleImgClass {
      //   position: absolute;
      //   left: 0;
      //   right: 0;
      //   top: 0;
      //   bottom: 0;
      //   transform: translate(3);
      // }
    }
  }
  .warn1_project_25 {
    margin: 0 auto;
    @include bg-box(416px, 118px, "project_25.png");
  }
  .warn1_project_50 {
    @include bg-box(416px, 118px, "project_50.png");
  }
  .warn1_project_75 {
    @include bg-box(416px, 118px, "project_75.png");
  }
  .warn1_project_100 {
    @include bg-box(416px, 118px, "project_100.png");
  }
}

@keyframes fade {
  from {
    opacity: 1;
  }
  25% {
    opacity: 0.9;
  }
  50% {
    opacity: 0.6;
  }
  75% {
    opacity: 0.9;
  }
  to {
    opacity: 1;
  }
}

@-webkit-keyframes fade {
  from {
    opacity: 1;
  }
  25% {
    opacity: 0.9;
  }
  50% {
    opacity: 0.6;
  }
  75% {
    opacity: 0.9;
  }
  to {
    opacity: 1;
  }
}

.slash {
  animation: fade 2500ms infinite;
  -webkit-animation: fade 2500ms infinite;
}

.yellow-warn1 {
  background: linear-gradient(180deg, #6b6210 0%, #6b621050 100%) !important;
}

.red-warn1 {
  background: linear-gradient(180deg, #460000 0%, #46000050 100%) !important;
}
.warn1.warn1_green {
  background-image: url("./img/warn1_green.png");
  background-size: 100% 100% !important;
}
.warn1.red-warn1_green {
  background-image: url("./img/warn1red_green_.png") !important;
  background-size: 100% 100% !important;
}
.warn1.yellow-warn1_green {
  background-image: url("./img/warn1yellow_green_.png") !important;
  background-size: 100% 100% !important;
}
</style>
<style lang="scss" scoped>
.popup-type1-title_green {
  color: #30d594 !important;
  &::before {
    background: #dffff3 !important;
    box-shadow: 0px 0px 7px 0px rgba(48, 213, 148, 0.81) !important;
    border: 1px solid #30d594 !important;
  }
}
.done_green {
  color: #30d594 !important;
}
.detailImg {
  max-width: 100%;
  max-height: 280px !important;
  display: block;
  margin: 20px auto;
}
</style>
<style lang="scss" >
.el-image-viewer__wrapper {
  z-index: 999999;
  height: 400px;
  top: auto;
  bottom: 81px;
}
.el-image-viewer__prev {
  display: none;
}
.el-image-viewer__next {
  display: none;
}
.el-image-viewer__actions {
  display: none;
}
</style>
